import { GestureResponderEvent, StyleSheet } from 'react-native';

import { SlotButtonContainer } from './LocationSlots';
import { CampItemResponse } from '../../api/camps';
import { Location } from '../../api/search';
import { useCheckoutPropUpdate } from '../../contexts/checkout';
import useAppNavigation from '../../hooks/useAppNavigation';
import useCampsQuery from '../../hooks/useCampsQuery';
import { dateStringToHuman } from '../../utils/date';
import { LocationCtaButtonVertical } from '../Button';
import { View } from '../Themed';

export default function CampSlotButtons({
  location,
  onPress,
}: {
  location: Location;
  onPress?: (camp: CampItemResponse) => void;
}) {
  const locationId = location.id;
  const { data, isLoading, error } = useCampsQuery(locationId);

  if (isLoading) {
    return (
      <>
        <SlotButtonContainer>
          <View style={styles.loadingStyle} />
        </SlotButtonContainer>
        <SlotButtonContainer>
          <View style={styles.loadingStyle} />
        </SlotButtonContainer>
      </>
    );
  }

  if (error) {
    return null;
  }

  return (
    <>
      {data
        ? data.map((camp) => (
            <SlotButtonContainer key={camp.id}>
              <CampSlotButton
                camp={camp}
                locationNameId={location.nameId}
                onPress={onPress}
              />
            </SlotButtonContainer>
          ))
        : null}
    </>
  );
}

function CampSlotButton({
  camp,
  locationNameId,
  onPress,
}: {
  camp: CampItemResponse;
  locationNameId: string;
  onPress?: (camp: CampItemResponse) => void;
}) {
  const updateCheckoutProp = useCheckoutPropUpdate();
  const { navigate } = useAppNavigation();
  const { name, start_date, end_date } = camp;

  const handlePress = (e: GestureResponderEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (onPress) {
      onPress(camp);
      return;
    }

    updateCheckoutProp(camp, 'campDetails');
    navigate('Location', { nameId: locationNameId });
  };

  return (
    <LocationCtaButtonVertical
      onPress={handlePress}
      top={name}
      bottom={`${dateStringToHuman(start_date, { month: 'short', day: 'numeric' })} - ${dateStringToHuman(end_date, { month: 'short', day: 'numeric' })}`}
    />
  );
}

const styles = StyleSheet.create({
  loadingStyle: {
    width: '100%',
    height: 35,
    backgroundColor: '#eee',
    borderRadius: 5,
  },
});
